// extracted by mini-css-extract-plugin
export var alertIcon = "_rr-0";